import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "row q-mb-md" }
const _hoisted_3 = { style: {"width":"100%","overflow-x":"auto"} }
const _hoisted_4 = { class: "midia-app-title-header-table-lg" }
const _hoisted_5 = { class: "row items-center no-wrap" }
const _hoisted_6 = { class: "midia-app-label-lg" }
const _hoisted_7 = { class: "midia-app-label-lg" }
const _hoisted_8 = { class: "midia-app-label-lg" }
const _hoisted_9 = { class: "midia-app-label-lg" }
const _hoisted_10 = { class: "midia-app-label-lg" }
const _hoisted_11 = { class: "midia-app-label-lg" }
const _hoisted_12 = { class: "midia-app-label-lg" }
const _hoisted_13 = { class: "row justify-end q-mt-md" }

import { ref, watch, computed } from "vue"
import { EnumButtonSizes } from "@/enums/enums"
import { usePCStore } from "@/stores/pcStore"
import { useCampaignStore } from "@/stores/campaignStore"
import { usePagesUtilStore } from "@/stores/pagesUtilStore"
import { PcModel } from "@/models/PcModel"
import { useInstitutionalStore } from "@/stores/institutionalStore"


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPCsInstitutional',
  setup(__props) {

const pcStore = usePCStore()
const campaignStore = useCampaignStore()
const pagesUtilStore = usePagesUtilStore()

const searchPcs = ref('')

const institutionalStore = useInstitutionalStore()


const loadingTableContents = ref(false)

const pagination = ref({
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 0,
  sortBy: '',
  descending: false
})

/* ✅ COLUNAS PADRONIZADAS */
const qTablePCsColumns = [
  { name: 'codpontocaptura', label: 'Código', field: 'codpontocaptura', align: 'left' },
  { name: 'nompontocaptura', label: 'Nome PC', field: 'nompontocaptura', align: 'left' },
  { name: 'nomcidredeautoatndto', label: 'Cidade', field: 'nomcidredeautoatndto', align: 'left' },
  { name: 'ufredeautoatndto', label: 'UF', field: 'ufredeautoatndto', align: 'left' },
  { name: 'nomsubredeautoatndto', label: 'Subrede', field: 'nomsubredeautoatndto', align: 'left' },
  { name: 'nomsegmmerclocalptoatndto', label: 'Segmento', field: 'nomsegmmerclocalptoatndto', align: 'left' },
  { name: 'nomtpmaqautoatndto', label: 'Tipo Máquina', field: 'nomtpmaqautoatndto', align: 'left' }
]

const qTablePCsVisibleColumns = [
  'codpontocaptura',
  'nompontocaptura',
  'nomcidredeautoatndto',
  'ufredeautoatndto',
  'nomsubredeautoatndto',
  'nomsegmmerclocalptoatndto',
  'nomtpmaqautoatndto'
]

/* ✅ REQUEST SERVER-SIDE */
const updatePagination = (pageNumberApi: number, total: number, size: number) => {
  pagination.value.page = pageNumberApi + 1
  pagination.value.rowsNumber = total
  pagination.value.rowsPerPage = size
}

const onRequest = async ({ pagination }: any) => {
  try {
    loadingTableContents.value = true

    const result = await pcStore.fetchPCs(
      pagination.page - 1,
      pagination.rowsPerPage
    )

    if (result) {
      updatePagination(
        result.pageable.pageNumber,
        result.totalElements,
        result.pageable.pageSize
      )
    }

  } finally {
    loadingTableContents.value = false
  }
}

/* ✅ CONTINUAR */
/*const onContinueBtnClick = () => {
  campaignStore.focusedCampaign.pcs.push(
    ...pcStore.selectedPCs.map(pc => new PcModel(pc))
  )

  campaignStore.focusedCampaign.pcsIds =
    campaignStore.focusedCampaign.pcs.map(p => p.codpontocaptura)

  pagesUtilStore.showModalPCsInstitutional = false
}*/

const onContinueBtnClick = () => {
  const pcsSelecionados = pcStore.selectedPCs.map(
    pc => new PcModel(pc)
  )

  // ✅ continua funcionando para campanhas
  //campaignStore.focusedCampaign.pcs.push(...pcsSelecionados)

  //campaignStore.focusedCampaign.pcsIds =
    //campaignStore.focusedCampaign.pcs.map(p => p.codpontocaptura)

  // ✅ ✅ AGORA O IMPORTANTE (Institucional)
  if (institutionalStore.institutionalDetail) {
    institutionalStore.institutionalDetail.pcs = pcsSelecionados

    institutionalStore.institutionalDetail.pcsIds =
      pcsSelecionados.map(p => p.codpontocaptura)

      
  }

  console.log(pcsSelecionados);
  pagesUtilStore.showModalPCsInstitutional = false
}

watch(
  () => pagesUtilStore.showModalPCsInstitutional,
  (isOpen) => {
    if (isOpen) {
      pagination.value.rowsNumber = pcStore.totalElements
    }
  }
)

watch(searchPcs, async (val) => {
  pagination.value.page = 1

  const isNumero = !isNaN(Number(val))

  pcStore.pcFilter.filterPc.codpontocaptura = isNumero && val ? val : undefined
  pcStore.pcFilter.filterPc.nompontocaptura = !isNumero ? val : undefined

  const result = await pcStore.fetchPCs(0, pagination.value.rowsPerPage)

  if (result) {
    pagination.value.rowsNumber = result.totalElements
  }
})


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(pagesUtilStore).showModalPCsInstitutional,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pagesUtilStore).showModalPCsInstitutional) = $event)),
    "no-backdrop-dismiss": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "midia-app-padding-modal",
        style: {"width":"1200px","max-width":"95vw"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  class: "full-width",
                  placeholder: "Pesquisar PC (código, nome, cidade, UF...)",
                  modelValue: searchPcs.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPcs).value = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "search" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_table, {
                  ref: "qTablePCs",
                  rows: _unref(pcStore).pcs,
                  "row-key": "codpontocaptura",
                  columns: qTablePCsColumns,
                  "visible-columns": qTablePCsVisibleColumns,
                  selection: "multiple",
                  selected: _unref(pcStore).selectedPCs,
                  "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pcStore).selectedPCs) = $event)),
                  pagination: pagination.value,
                  "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((pagination).value = $event)),
                  onRequest: onRequest,
                  "rows-per-page-options": [10, 50, 100],
                  loading: loadingTableContents.value,
                  flat: "",
                  dense: "",
                  separator: "horizontal",
                  class: "midia-app-table",
                  "no-data-label": "Nenhum registro encontrado!",
                  "table-style": "min-width: 1100px"
                }, {
                  header: _withCtx((props) => [
                    _createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_th, {
                          "auto-width": "",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_checkbox, {
                              modelValue: props.selected,
                              "onUpdate:modelValue": ($event: any) => ((props.selected) = $event),
                              color: props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2',
                              "keep-color": !props.selected
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "keep-color"])
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                          return (_openBlock(), _createBlock(_component_q_th, {
                            key: col.name,
                            props: props
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(col.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["props"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, {
                      props: props,
                      class: "table-body-rows"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          "auto-width": "",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_checkbox, {
                              modelValue: props.selected,
                              "onUpdate:modelValue": ($event: any) => ((props.selected) = $event),
                              color: props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2',
                              "keep-color": !props.selected
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "keep-color"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_td, {
                          key: "codpontocaptura",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(props.row.codpontocaptura), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "nompontocaptura",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(props.row.nompontocaptura), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "nomcidredeautoatndto",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(props.row.nomcidredeautoatndto), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "ufredeautoatndto",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(props.row.ufredeautoatndto), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "nomsubredeautoatndto",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(props.row.nomsubredeautoatndto), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "nomsegmmerclocalptoatndto",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(props.row.nomsegmmerclocalptoatndto), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "nomtpmaqautoatndto",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(props.row.nomtpmaqautoatndto), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "selected", "pagination", "loading"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_c_q_btn, {
              propBtnLabel: "Continuar",
              propBtnSize: _unref(EnumButtonSizes).LARGE_1,
              onClick: onContinueBtnClick
            }, null, 8, ["propBtnSize"])
          ]),
          _createVNode(_component_q_inner_loading, {
            showing: _unref(pagesUtilStore).showLoading,
            label: "Aguarde..."
          }, null, 8, ["showing"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})